"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsScalarExprTreeSectionMatchContext = exports.IsScalarExprTreeSectionInitiallyOpenContext = exports.DecorateScalarExprTreeSectionChildrenContext = exports.ActiveTablesContext = exports.LocaleContext = exports.CustomTableSelectComponentFactoryContext = void 0;
const react_1 = require("react");
/** Context to override the table select component */
exports.CustomTableSelectComponentFactoryContext = (0, react_1.createContext)(null);
/** Context to set the locale */
exports.LocaleContext = (0, react_1.createContext)("en");
/** Optional list of tables (ids) being used. Some overrides of the table select component may use this to present
 * an initially short list to select from */
exports.ActiveTablesContext = (0, react_1.createContext)([]);
/**
 * Context for decorating sections in the expression picker with additional typing for options.
 */
exports.DecorateScalarExprTreeSectionChildrenContext = (0, react_1.createContext)(null);
/**
 * Context for overriding the initial open state of a section in the expression picker.
 * It expects an object with properties that match the section being targeted and returns a boolean indicating if the section should be initially open.
 */
exports.IsScalarExprTreeSectionInitiallyOpenContext = (0, react_1.createContext)(null);
/**
 * Context for overriding the filtering logic of a section within the expression picker.
 * This allows for custom filtering logic to be applied, determining if a section should be included or excluded based on the provided options.
 * filter is optional and can be used to filter the sections based on a string filter.
 */
exports.IsScalarExprTreeSectionMatchContext = (0, react_1.createContext)(null);
